<div class="grid">
  <!-- ===================== ESTADO ===================== -->
  <ng-container *ngIf="activeTab === 'estado'">
    <div class="col-12">
      <!-- Sin cuenta vinculada -->
      <ng-container *ngIf="instagramBotLoaded && !instagramBot">
        <div class="estado-connect-layout">
          <!-- Hero card izquierda -->
          <div class="estado-hero-card">
            <div class="estado-hero-banner"></div>
            <div class="estado-hero-body">
              <div>
                <h2 class="estado-hero-title">Conecta tu cuenta de Instagram</h2>
                <p class="estado-hero-sub">
                  Vincula una cuenta de Instagram Business para que el chatbot pueda responder
                  comentarios y mensajes directos automáticamente.
                </p>
              </div>
              <ol class="estado-steps">
                <li class="estado-step">
                  <div class="estado-step__dot">1</div>
                  <div class="estado-step__text">
                    <span class="estado-step__title">Cuenta Business o Creator</span>
                    <span class="estado-step__desc"
                      >Tu cuenta debe ser de tipo Business o Creator en Instagram.</span
                    >
                  </div>
                </li>
                <li class="estado-step">
                  <div class="estado-step__dot">2</div>
                  <div class="estado-step__text">
                    <span class="estado-step__title">Ten tus credenciales a mano</span>
                    <span class="estado-step__desc"
                      >Necesitarás acceso a tu cuenta de Instagram para completar la
                      autorización.</span
                    >
                  </div>
                </li>
                <li class="estado-step">
                  <div class="estado-step__dot">3</div>
                  <div class="estado-step__text">
                    <span class="estado-step__title">Autoriza el acceso</span>
                    <span class="estado-step__desc"
                      >Haz clic en Conectar y autoriza el acceso a tu cuenta.</span
                    >
                  </div>
                </li>
              </ol>
              <div class="estado-btn-stack">
                <globot-button
                  text="Conectar con Instagram"
                  styleClass="instagram"
                  icon="pi pi-instagram"
                  iconPosition="left"
                  width="w-100"
                  [loading]="loading"
                  (clickEvent)="linkInstagramAccount()"
                ></globot-button>
                <globot-button
                  *ngIf="pageSubscribed"
                  text="Usar una Página de Facebook vinculada"
                  styleClass="facebook-outline"
                  icon="pi pi-facebook"
                  iconPosition="left"
                  width="w-100"
                  [loading]="loading"
                  (clickEvent)="detectInstagramAccount()"
                ></globot-button>
              </div>
            </div>
          </div>

          <!-- Features columna derecha -->
          <div class="estado-features">
            <span class="estado-features__label">Una vez conectado podrás</span>
            <div class="estado-feature-card">
              <div class="estado-feature-card__icon"><i class="pi pi-comments"></i></div>
              <div class="estado-feature-card__text">
                <span class="estado-feature-card__title">Comentarios automáticos</span>
                <span class="estado-feature-card__desc">Responde sin intervención manual.</span>
              </div>
            </div>
            <div class="estado-feature-card">
              <div class="estado-feature-card__icon"><i class="pi pi-send"></i></div>
              <div class="estado-feature-card__text">
                <span class="estado-feature-card__title">Mensajes DM</span>
                <span class="estado-feature-card__desc">Envía DMs a quienes comenten.</span>
              </div>
            </div>
            <div class="estado-feature-card">
              <div class="estado-feature-card__icon"><i class="pi pi-tag"></i></div>
              <div class="estado-feature-card__text">
                <span class="estado-feature-card__title">Filtro por keywords</span>
                <span class="estado-feature-card__desc">Solo reacciona a palabras clave.</span>
              </div>
            </div>
            <div class="estado-feature-card">
              <div class="estado-feature-card__icon"><i class="pi pi-chart-bar"></i></div>
              <div class="estado-feature-card__text">
                <span class="estado-feature-card__title">Perfil y estadísticas</span>
                <span class="estado-feature-card__desc">Seguidores, publicaciones y más.</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Con cuenta vinculada -->
      <ng-container *ngIf="instagramBotLoaded && instagramBot">
        <div class="estado-connected-layout">
          <!-- Top row: Account card + DM switch -->
          <div class="estado-top-row">
            <!-- Account card -->
            <div class="estado-account-card">
              <div class="estado-avatar-ring">
                <img
                  *ngIf="instagramBot.profile_picture_url"
                  [src]="instagramBot.profile_picture_url"
                  class="estado-avatar"
                  alt=""
                />
                <div
                  *ngIf="!instagramBot.profile_picture_url"
                  class="estado-avatar estado-avatar--placeholder"
                >
                  <i class="pi pi-user"></i>
                </div>
              </div>
              <div class="estado-account-card__info">
                <div class="estado-account-card__name-row">
                  <span class="estado-account-card__name">{{ instagramBot.account_name }}</span>
                  <i
                    class="pi estado-account-card__refresh-btn"
                    [class.pi-refresh]="!refreshing"
                    [class.pi-spin]="refreshing"
                    [class.pi-spinner]="refreshing"
                    [class.estado-account-card__refresh-btn--disabled]="refreshing"
                    pTooltip="Actualizar foto y nombre del perfil"
                    tooltipPosition="top"
                    (click)="!refreshing && refreshInstagramProfile()"
                  ></i>
                </div>
                <span class="estado-account-card__handle"
                  >@{{ instagramBot.account_username }}</span
                >
              </div>
              <div class="estado-account-card__stats">
                <div class="estado-stat">
                  <span class="estado-stat__val">{{ instagramBot.media_count ?? '—' }}</span>
                  <span class="estado-stat__lbl">posts</span>
                </div>
                <div class="estado-stat">
                  <span class="estado-stat__val">{{ instagramBot.followers_count ?? '—' }}</span>
                  <span class="estado-stat__lbl">seguidores</span>
                </div>
                <div class="estado-stat">
                  <span class="estado-stat__val">{{ instagramBot.follows_count ?? '—' }}</span>
                  <span class="estado-stat__lbl">seguidos</span>
                </div>
              </div>
            </div>

            <!-- DM switch card -->
            <div class="estado-dm-card">
              <div class="estado-dm-card__top">
                <div>
                  <div class="cs-label-with-info">
                    <span class="estado-dm-card__title"
                      >Respuestas automáticas por mensaje privado</span
                    >
                    <i
                      class="pi pi-info-circle cs-info-icon"
                      pTooltip="Cuando alguien te escriba un mensaje directo en Instagram, el chatbot responderá automáticamente usando inteligencia artificial."
                      tooltipPosition="top"
                    ></i>
                  </div>
                  <span class="estado-dm-card__desc"
                    >El chatbot responde automáticamente los mensajes directos que recibe tu cuenta
                    de Instagram.</span
                  >
                </div>
                <p-inputSwitch
                  [ngModel]="botEnabled"
                  (onChange)="switchChanged($event)"
                ></p-inputSwitch>
              </div>
            </div>
          </div>
          <!-- /estado-top-row -->

          <!-- Status banner -->
          <div
            class="estado-status-banner"
            [class.estado-status-banner--active]="botEnabled"
            [class.estado-status-banner--inactive]="!botEnabled"
          >
            <div class="estado-status-banner__left">
              <div
                class="estado-status-dot"
                [class.estado-status-dot--active]="botEnabled"
                [class.estado-status-dot--inactive]="!botEnabled"
              >
                <i [class]="botEnabled ? 'pi pi-check-circle' : 'pi pi-times-circle'"></i>
              </div>
              <div>
                <span class="estado-status-title">
                  {{
                    botEnabled ? 'Canal conectado y activo' : 'Canal conectado, respuestas pausadas'
                  }}
                </span>
                <span class="estado-status-sub">@{{ instagramBot.account_username }}</span>
              </div>
            </div>
            <div class="estado-status-banner__actions">
              <button
                pButton
                pRipple
                type="button"
                class="p-button-outlined p-button-danger p-button-sm"
                icon="pi pi-times"
                label="Desconectar"
                [loading]="loading"
                (click)="unlinkInstagramAccount()"
              ></button>
            </div>
          </div>

          <div class="attention-schedule-wrapper" *ngIf="attentionScheduleConfig">
            <globot-attention-schedule-config
              [config]="attentionScheduleConfig"
              [saving]="savingAttentionSchedule"
              channelNote="En Instagram, este horario aplica tanto a mensajes directos como a comentarios."
              (save)="saveAttentionSchedule($event)"
            ></globot-attention-schedule-config>
          </div>

          <!-- Stats hoy -->
          <div class="ig-stats-row">
            <!-- Card 1: Comentarios -->
            <div class="ig-stat-card">
              <div class="ig-stat-card__header">
                <div class="ig-stat-card__icon ig-stat-card__icon--purple">
                  <i class="pi pi-comments"></i>
                </div>
                <span class="ig-stat-card__title">Comentarios respondidos este mes</span>
              </div>
              <div class="ig-stat-card__numbers">
                <div class="ig-stat-card__num">
                  <span
                    class="ig-stat-card__val"
                    [class.ig-stat-card__val--empty]="!commentStats?.total_received"
                    >{{ loadingStats ? '—' : commentStats?.total_received ?? 0 }}</span
                  >
                  <span class="ig-stat-card__lbl">total</span>
                </div>
                <span class="ig-stat-card__sep">·</span>
                <div class="ig-stat-card__num">
                  <span
                    class="ig-stat-card__val"
                    [class.ig-stat-card__val--empty]="!commentStatsDmSent"
                    >{{ loadingStats ? '—' : commentStatsDmSent }}</span
                  >
                  <span class="ig-stat-card__lbl">con DM</span>
                </div>
                <span class="ig-stat-card__sep">·</span>
                <div class="ig-stat-card__num">
                  <span
                    class="ig-stat-card__val"
                    [class.ig-stat-card__val--empty]="!commentStatsPublicSent"
                    >{{ loadingStats ? '—' : commentStatsPublicSent }}</span
                  >
                  <span class="ig-stat-card__lbl">públicos</span>
                </div>
              </div>
            </div>

            <!-- Card 2: DMs Instagram -->
            <div class="ig-stat-card">
              <div class="ig-stat-card__header">
                <span
                  class="material-symbols-outlined ig-stat-card__icon ig-stat-card__icon--indigo"
                  >smart_toy</span
                >
                <span class="ig-stat-card__title">Mensajes DM de Instagram este mes</span>
              </div>
              <div class="ig-stat-card__numbers">
                <div class="ig-stat-card__num">
                  <span
                    class="ig-stat-card__val"
                    [class.ig-stat-card__val--empty]="!igDmStats?.ig_count"
                    >{{ loadingIgDmStats ? '—' : igDmStats?.ig_count ?? 0 }}</span
                  >
                  <span class="ig-stat-card__lbl">conversaciones</span>
                </div>
                <span class="ig-stat-card__sep">·</span>
                <div class="ig-stat-card__num">
                  <span
                    class="ig-stat-card__val"
                    [class.ig-stat-card__val--empty]="!igDmStats?.ig_messages_count"
                    >{{ loadingIgDmStats ? '—' : igDmStats?.ig_messages_count ?? 0 }}</span
                  >
                  <span class="ig-stat-card__lbl">mensajes</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Comentarios recientes -->
          <div class="estado-comments-card">
            <div class="estado-comments-header">
              <span class="estado-comments-title">Comentarios recientes</span>
            </div>

            <div *ngIf="loadingComments" class="estado-comments-empty">
              <i class="pi pi-spin pi-spinner"></i>
              <span>Cargando comentarios...</span>
            </div>

            <div
              *ngIf="!loadingComments && recentComments.length === 0"
              class="estado-comments-empty"
            >
              <i class="pi pi-comments"></i>
              <span>Aún no hay comentarios registrados en este canal.</span>
            </div>

            <div
              *ngFor="let comment of recentComments; trackBy: trackByCommentId; let last = last"
              class="estado-comment-row"
              [class.estado-comment-row--last]="last && !hasMoreComments"
            >
              <div class="estado-comment-avatar">
                <img
                  *ngIf="comment.media_image_url"
                  [src]="comment.media_image_url"
                  class="estado-comment-avatar-img"
                  alt="Publicación"
                  (error)="comment.media_image_url = undefined"
                />
                <i *ngIf="!comment.media_image_url" class="pi pi-image"></i>
              </div>
              <div class="estado-comment-content">
                <div class="estado-comment-meta">
                  <a
                    *ngIf="comment.commenter_username"
                    class="estado-comment-user estado-comment-user--link"
                    href="https://www.instagram.com/{{ comment.commenter_username }}/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @{{ comment.commenter_username }}
                  </a>
                  <span *ngIf="!comment.commenter_username" class="estado-comment-user">{{
                    comment.commenter_ig_id
                  }}</span>
                  <span class="estado-comment-time">{{ timeAgo(comment.created_at) }}</span>
                </div>
                <a
                  *ngIf="comment.media_permalink"
                  [href]="comment.media_permalink"
                  class="estado-comment-text estado-comment-text--link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ comment.comment_text || '(sin texto)' }}
                </a>
                <p *ngIf="!comment.media_permalink" class="estado-comment-text">
                  {{ comment.comment_text || '(sin texto)' }}
                </p>
              </div>
            </div>

            <div *ngIf="hasMoreComments && !loadingComments" class="estado-comments-footer">
              <button
                pButton
                pRipple
                type="button"
                class="p-button-text p-button-sm"
                icon="pi pi-list"
                label="Ver todos los comentarios"
                (click)="openCommentsDialog()"
              ></button>
            </div>
          </div>

          <!-- Token alert -->
          <div
            *ngIf="showTokenAlert"
            class="token-alert-card"
            [class.token-alert-card--warn]="instagramBot.token_status === 'expiring_soon'"
            [class.token-alert-card--expired]="instagramBot.token_status === 'expired'"
          >
            <div class="token-alert-card__header">
              <i
                class="pi"
                [class.pi-exclamation-triangle]="instagramBot.token_status === 'expiring_soon'"
                [class.pi-times-circle]="instagramBot.token_status === 'expired'"
              ></i>
              <span class="token-alert-card__title">
                {{
                  instagramBot.token_status === 'expired'
                    ? 'Token expirado'
                    : 'Token próximo a expirar'
                }}
              </span>
            </div>

            <ng-container *ngIf="instagramBot.token_status === 'expiring_soon'">
              <div class="token-alert-card__progress-info">
                <span>{{ tokenDaysLeft }} días restantes</span>
                <span>{{ instagramBot.token_expires_at | date : 'd MMM yyyy' }}</span>
              </div>
              <div class="token-alert-card__track">
                <div class="token-alert-card__fill" [style.width.%]="tokenExpiryPercent"></div>
              </div>
            </ng-container>

            <p class="token-alert-card__msg">
              {{
                instagramBot.token_status === 'expired'
                  ? 'Tu token de Instagram expiró. Reconecta la cuenta para que el bot siga funcionando.'
                  : 'Tu token de Instagram vence pronto. Renuévalo para evitar interrupciones.'
              }}
            </p>

            <button
              *ngIf="instagramBot.token_status === 'expiring_soon'"
              pButton
              type="button"
              class="token-alert-card__btn token-alert-card__btn--warn"
              icon="pi pi-refresh"
              label="Renovar conexión"
              [loading]="refreshingToken"
              (click)="refreshInstagramTokenHandler()"
            ></button>

            <button
              *ngIf="instagramBot.token_status === 'expired'"
              pButton
              type="button"
              class="token-alert-card__btn token-alert-card__btn--expired"
              icon="pi pi-link"
              label="Reconectar cuenta"
              [loading]="loading"
              (click)="linkInstagramAccount()"
            ></button>
          </div>
          <!-- /token-alert-card -->
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- ===================== COMENTARIOS ===================== -->
  <ng-container *ngIf="activeTab === 'comments'">
    <div class="col-12" *ngIf="!instagramBot">
      <p>Completa la integración primero para configurar los comentarios.</p>
    </div>

    <div class="col-12" *ngIf="instagramBot">
      <div class="comments-layout">
        <!-- Formulario -->
        <div class="comments-form-card">
          <!-- S1: Toggle principal -->
          <div class="cs-section cs-section--row cs-section--sep">
            <div class="cs-toggle-text">
              <div class="cs-label-with-info">
                <span class="cs-toggle-title">Activar respuestas predefinidas a comentarios</span>
                <i
                  class="pi pi-info-circle cs-info-icon"
                  pTooltip="Cuando está activo, el chatbot envía mensajes fijos (no generados por IA) a quienes comenten en tus publicaciones."
                  tooltipPosition="top"
                ></i>
              </div>
              <span class="cs-toggle-sub"
                >Cuando alguien comente, se enviará automáticamente un mensaje predefinido por DM o
                como respuesta pública, sin intervención de la IA.</span
              >
            </div>
            <p-inputSwitch
              *ngIf="commentsConfigLoaded"
              [disabled]="savingCommentsConfig"
              [(ngModel)]="commentsReplyEnabled"
              (onChange)="commentsReplySwitchChanged($event)"
            ></p-inputSwitch>
          </div>

          <!-- S2: Tipo de activación -->
          <div class="cs-section cs-section--sep" [class.cs-section--muted]="!commentsReplyEnabled">
            <div class="cs-label-with-info">
              <span class="cs-label">¿A qué comentarios debe responder?</span>
              <i
                class="pi pi-info-circle cs-info-icon"
                pTooltip="Define si el chatbot reacciona a todos los comentarios o solo a los que contienen palabras específicas que tú configures."
                tooltipPosition="top"
              ></i>
            </div>
            <div class="cs-radio-group">
              <div class="cs-radio-option">
                <p-radioButton
                  name="triggerType"
                  value="any"
                  [(ngModel)]="commentsTriggerType"
                  [disabled]="savingCommentsConfig"
                  inputId="trigger_any"
                ></p-radioButton>
                <label for="trigger_any" class="cs-radio-label">
                  <span class="cs-radio-label__title">Todos los comentarios</span>
                  <span class="cs-radio-label__desc"
                    >El chatbot responde a cualquier comentario que recibas.</span
                  >
                </label>
              </div>
              <div class="cs-radio-option">
                <p-radioButton
                  name="triggerType"
                  value="keywords"
                  [(ngModel)]="commentsTriggerType"
                  [disabled]="savingCommentsConfig"
                  inputId="trigger_keywords"
                ></p-radioButton>
                <label for="trigger_keywords" class="cs-radio-label">
                  <span class="cs-radio-label__title">Palabras clave</span>
                  <span class="cs-radio-label__desc"
                    >Solo reacciona cuando el comentario contiene palabras específicas.</span
                  >
                </label>
              </div>
            </div>

            <div class="cs-kw-box" [class.cs-kw-box--disabled]="commentsTriggerType !== 'keywords'">
              <div class="cs-kw-header">
                <span class="cs-kw-label">Palabras clave activas</span>
                <span class="cs-kw-count"
                  >{{ commentsKeywordsArray.length }}
                  {{ commentsKeywordsArray.length === 1 ? 'palabra' : 'palabras' }}</span
                >
              </div>
              <p-chips
                [(ngModel)]="commentsKeywordsArray"
                [disabled]="savingCommentsConfig || commentsTriggerType !== 'keywords'"
                [addOnBlur]="true"
                [addOnTab]="true"
                separator=","
                placeholder="Escribe y presiona Enter..."
                styleClass="cs-chips"
              ></p-chips>
            </div>
          </div>

          <!-- S3: Acciones automáticas -->
          <div class="cs-section cs-section--sep" [class.cs-section--muted]="!commentsReplyEnabled">
            <div class="cs-label-with-info">
              <span class="cs-label">¿Cómo quieres responder?</span>
              <i
                class="pi pi-info-circle cs-info-icon"
                pTooltip="Elige qué hace el chatbot al detectar un comentario: enviar un DM privado, responder públicamente en el hilo, o ambas."
                tooltipPosition="top"
              ></i>
            </div>
            <div class="cs-action-cards">
              <!-- Card DM -->
              <div class="cs-action-card" [class.cs-action-card--dm]="commentsReplySendDm">
                <div class="cs-action-card__top">
                  <div class="cs-action-card__icon cs-action-card__icon--dm">
                    <i class="pi pi-send"></i>
                  </div>
                  <p-inputSwitch
                    [(ngModel)]="commentsReplySendDm"
                    [disabled]="savingCommentsConfig || !commentsReplyEnabled"
                  ></p-inputSwitch>
                </div>
                <div class="cs-label-with-info">
                  <span class="cs-action-card__title">Enviar mensaje privado</span>
                  <i
                    class="pi pi-info-circle cs-info-icon"
                    pTooltip="El usuario recibirá un mensaje directo y privado. Solo él lo verá, no aparece en los comentarios de la publicación."
                    tooltipPosition="top"
                  ></i>
                </div>
                <span class="cs-action-card__desc"
                  >Envía un DM privado al autor del comentario.</span
                >
                <div
                  *ngIf="commentsReplySendDm"
                  class="cs-action-card__tag cs-action-card__tag--dm"
                >
                  Activo
                </div>
              </div>

              <!-- Card respuesta pública -->
              <div class="cs-action-card" [class.cs-action-card--public]="commentsReplySendPublic">
                <div class="cs-action-card__top">
                  <div class="cs-action-card__icon cs-action-card__icon--public">
                    <i class="pi pi-comment"></i>
                  </div>
                  <p-inputSwitch
                    [(ngModel)]="commentsReplySendPublic"
                    [disabled]="savingCommentsConfig || !commentsReplyEnabled"
                  ></p-inputSwitch>
                </div>
                <div class="cs-label-with-info">
                  <span class="cs-action-card__title">Responder en los comentarios</span>
                  <i
                    class="pi pi-info-circle cs-info-icon"
                    pTooltip="La respuesta se publicará como comentario visible para todos en la publicación. Ideal para mostrar engagement."
                    tooltipPosition="top"
                  ></i>
                </div>
                <span class="cs-action-card__desc"
                  >Publica una respuesta visible en los comentarios de la publicación.</span
                >
                <div
                  *ngIf="commentsReplySendPublic"
                  class="cs-action-card__tag cs-action-card__tag--public"
                >
                  Activo
                </div>
              </div>
            </div>
          </div>

          <!-- S4: Mensajes -->
          <div
            class="cs-section cs-section--sep"
            [class.cs-section--muted]="!commentsReplyEnabled"
            *ngIf="commentsReplySendDm || commentsReplySendPublic"
          >
            <span class="cs-label">Mensajes</span>

            <div *ngIf="commentsReplySendDm" class="cs-msg-field">
              <div class="cs-msg-label-row">
                <span class="cs-msg-label">Mensaje privado</span>
                <div class="cs-msg-tag cs-msg-tag--dm">
                  <i class="pi pi-send"></i>
                  <span>Privado</span>
                </div>
              </div>
              <textarea
                pInputTextarea
                class="cs-msg-textarea cs-msg-textarea--dm"
                [rows]="3"
                [disabled]="savingCommentsConfig"
                [(ngModel)]="commentsPredefinedMessage"
                placeholder="Ej.: Gracias por comentar. Te escribimos por DM."
                maxlength="500"
              ></textarea>
              <div class="cs-msg-counter">{{ (commentsPredefinedMessage || '').length }}/500</div>
            </div>

            <div *ngIf="commentsReplySendPublic" class="cs-msg-field">
              <div class="cs-msg-label-row">
                <span class="cs-msg-label">Respuesta en los comentarios</span>
                <div class="cs-msg-tag cs-msg-tag--public">
                  <i class="pi pi-comment"></i>
                  <span>Público · visible en comentarios</span>
                </div>
              </div>
              <textarea
                pInputTextarea
                class="cs-msg-textarea cs-msg-textarea--public"
                [rows]="3"
                [disabled]="savingCommentsConfig"
                [(ngModel)]="commentsPredefinedMessagePublic"
                placeholder="Ej.: ¡Gracias! Te enviamos los detalles por mensaje directo."
                maxlength="500"
              ></textarea>
              <div class="cs-msg-counter">
                {{ (commentsPredefinedMessagePublic || '').length }}/500
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="cs-footer">
            <button
              pButton
              type="button"
              label="Guardar cambios"
              icon="pi pi-save"
              iconPos="left"
              [disabled]="savingCommentsConfig"
              [loading]="savingCommentsConfig"
              (click)="saveCommentsConfiguration()"
            ></button>
          </div>
        </div>

        <!-- Vista previa -->
        <div class="comments-preview-col">
          <div class="cs-preview-hdr">
            <span class="cs-preview-title">Vista previa</span>
            <span class="cs-preview-sub">Así verán tus usuarios las respuestas</span>
          </div>
          <globot-instagram-phone-preview
            [username]="instagramBot.account_username || 'tu.cuenta'"
            [profilePictureUrl]="instagramBot.profile_picture_url || ''"
            [dmMessage]="commentsPredefinedMessage"
            [sendDm]="commentsReplySendDm"
            [sendPublicReply]="commentsReplySendPublic"
            [publicReplyMessage]="commentsPredefinedMessagePublic"
          ></globot-instagram-phone-preview>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ===================== DIALOG HISTORIAL COMENTARIOS ===================== -->
  <p-dialog
    [(visible)]="commentsDialogVisible"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    header="Historial de comentarios"
    styleClass="comments-history-dialog"
    [style]="{ width: '640px', maxWidth: '95vw' }"
  >
    <div class="chd-body">
      <div *ngIf="dialogLoading" class="chd-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Cargando...</span>
      </div>

      <div *ngIf="!dialogLoading && dialogComments.length === 0" class="chd-empty">
        <i class="pi pi-comments"></i>
        <span>Sin comentarios en esta página.</span>
      </div>

      <div
        *ngFor="let comment of dialogComments; trackBy: trackByCommentId; let last = last"
        class="chd-comment-row"
        [class.chd-comment-row--last]="last"
      >
        <div class="chd-avatar">
          <img
            *ngIf="comment.media_image_url"
            [src]="comment.media_image_url"
            class="chd-avatar-img"
            alt="Publicación"
            (error)="comment.media_image_url = undefined"
          />
          <i *ngIf="!comment.media_image_url" class="pi pi-image"></i>
        </div>
        <div class="chd-content">
          <div class="chd-meta">
            <a
              *ngIf="comment.commenter_username"
              class="chd-user chd-user--link"
              href="https://www.instagram.com/{{ comment.commenter_username }}/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @{{ comment.commenter_username }}
            </a>
            <span *ngIf="!comment.commenter_username" class="chd-user">{{
              comment.commenter_ig_id
            }}</span>
            <span class="chd-time">{{ timeAgo(comment.created_at) }}</span>
          </div>
          <a
            *ngIf="comment.media_permalink"
            [href]="comment.media_permalink"
            class="chd-text chd-text--link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ comment.comment_text || '(sin texto)' }}
          </a>
          <p *ngIf="!comment.media_permalink" class="chd-text">
            {{ comment.comment_text || '(sin texto)' }}
          </p>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="chd-pagination">
        <span class="chd-pagination__info">
          {{ dialogTotal }} comentario{{ dialogTotal !== 1 ? 's' : '' }} en total
        </span>
        <div class="chd-pagination__controls">
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-angle-left"
            class="p-button-outlined p-button-sm"
            aria-label="Página anterior"
            [disabled]="dialogPage <= 1 || dialogLoading"
            (click)="loadDialogPage(dialogPage - 1)"
          ></button>
          <span class="chd-pagination__page">{{ dialogPage }} / {{ dialogTotalPages }}</span>
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-angle-right"
            class="p-button-outlined p-button-sm"
            aria-label="Página siguiente"
            [disabled]="dialogPage >= dialogTotalPages || dialogLoading"
            (click)="loadDialogPage(dialogPage + 1)"
          ></button>
        </div>
      </div>
    </ng-template>
  </p-dialog>

  <!-- ===================== DIALOGS (siempre presentes) ===================== -->
  <p-dialog
    [(visible)]="dialogVisible"
    [modal]="true"
    (onHide)="closeDialog($event)"
    [closable]="false"
  >
    <div class="content-dialog">
      <h1>Cuenta detectada</h1>
      <div class="circular-image">
        <img src="{{ instagramDetected?.profile_picture_url }}" alt="Imagen de Ejemplo" />
      </div>
      <br />
      <p>
        <b>{{ instagramDetected?.name }}</b>
      </p>
      <p>{{ '@' + instagramDetected?.username }}</p>
      <br />
      <div class="account_data">
        <div class="info_items">
          <p>posts</p>
          <b>{{ instagramDetected?.media_count }}</b>
        </div>
        <div class="info_items">
          <p>followers</p>
          <b>{{ instagramDetected?.followers_count }}</b>
        </div>
        <div class="info_items">
          <p>follows</p>
          <b>{{ instagramDetected?.follows_count }}</b>
        </div>
      </div>
      <br />
      <br />
      <button
        pButton
        type="button"
        icon="pi pi-instagram"
        iconPos="left"
        label="Continuar"
        (click)="subscribeIgAccount()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        label="Cancelar"
        class="p-button-text"
        (click)="closeDialog(false)"
      ></button>
    </div>
  </p-dialog>

  <p-dialog
    [(visible)]="deleteDialogVisible"
    [modal]="true"
    [closable]="false"
    (onHide)="closeDialog($event)"
  >
    <div class="content-dialog-delete">
      <h1>Desconectar de Instagram</h1>
      <br />
      <div class="description-content">
        <i class="pi pi-exclamation-triangle" style="color: #eab308"></i>
        <div class="description">
          <p>
            ¿Deseas desconectar tu asistente de este canal? Tus datos se <br />perderán y tendrás
            que realizar todo el proceso nuevamente.
          </p>
        </div>
      </div>
      <br />
      <div style="display: flex; flex-direction: row; justify-content: flex-end">
        <button
          pButton
          pRipple
          type="button"
          label="Cancelar"
          class="p-button-text"
          (click)="closeDialogDelete(false)"
        ></button>
        <button
          pButton
          type="button"
          label="Si, desconectar"
          (click)="deleteAccountSubscription()"
        ></button>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    [(visible)]="notFoundedAccountDialog"
    [modal]="true"
    [closable]="false"
    (onHide)="closeDialog($event)"
  >
    <div class="content-dialog-delete">
      <h1>Detectar cuenta vinculada</h1>
      <br />
      <div class="description-content">
        <i class="pi pi-exclamation-triangle" style="color: #eab308"></i>
        <div class="description">
          <p>
            No se encontró una cuenta de Instagram asociada a la página de <br />
            Facebook de este asistente. Por favor, consulta el paso a paso en <br />
            <a href="https://globot.ai/tutoriales/instagram" target="_blank"
              >¿Cómo integrar mi asistente en Instagram?</a
            >
            para que tu asistente <br />
            responda consultas por este canal.
          </p>
        </div>
      </div>
      <br />
      <div style="display: flex; flex-direction: row; justify-content: flex-end">
        <button
          pButton
          pRipple
          type="button"
          label="Cancelar"
          class="p-button-text"
          (click)="closeDialogNotFoundedAccount(false)"
        ></button>
      </div>
    </div>
  </p-dialog>
</div>
